// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".super-search-description-list[data-v-2b3ceb00]{list-style-type:none}.super-search-description-list>li[data-v-2b3ceb00]{margin-top:8px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
